module.exports = __webpack_public_path__ + "img/egg_clouds_happy.2bde8987.svg";